<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uKREXG/tc-custom/9781591812401.jpg?1718106102765" alt="This image is the cover for the book Creaky Traveler in the North West Highlands of Scotland"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Creaky Traveler in the North West Highlands of Scotland
      </h1>
      <p class="bookDescription body article font2">
        <b>“The author has found a good combination of travelogue, guidebook and charm to capture readers’ attention. Aimed at more mature outdoor enthusiasts.” —<i>The Scots Magazine</i></b><br/><br/>On a journey of discovery, Warren and Gerda Rovetch, both “creaky” themselves, explore the hidden places of Great Britain’s last wilderness, the rugged and startling coast of Scotland’s North West Highlands. They bring fresh perspectives to the environmental, cultural, and spiritual dimensions of their experience as their journey moves at an easy pace from village pubs and croft houses to places of untouched natural beauty and solitude. Celtic history and tradition come alive as our hosts meander their way along. Part travelogue, part guidebook, but all charm and wit, this book transports us to another culture where we have much to learn.<br/><br/><b>“I have never met a travel book with so much love in it—for nature, for the oddities encountered, for good food, and for the privilege of living on this planet. The book is deliciously readable and reveals a breadth of curiosity that is enticing.” —Anthony Smith, author of <i>Explorers of the Amazon</i> and the TV series, <i>Wilderness</i></b><br/><br/><b></b><br/><br/><b>“What happens to the backpacking crowd when their backs grow too weak with age to shoulder the burden, when the lure of the open road is still strong, but the feet are better suited to loafers than hiking boots? Do nights of camaraderie in student-packed hostels turn to breakfasts in bed at bed-and-breakfasts? Does hitchhiking give way to most car rentals? Well traveled, 70-something adventurers Warren Rovetch and his wife Gerda answer these questions and many more in a charming yet practical new book.” —<i>Travel with a Challenge</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Warren Rovetch
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sentient Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?261b31ba